import Circle from "./Circle";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

export interface RadioProps {
  id?: string;
  label?: string;
  value: string;
  isSelected?: boolean;
  labelStyle?: string;
  circleSize?: number;
  containerStyle?: string;
  name?: string;
  disabled?: boolean;
  onClick?: (value: string, name?: string) => void;
}

const Radio = ({
  id,
  label,
  value,
  isSelected,
  circleSize = 22,
  labelStyle,
  containerStyle,
  name,
  disabled,
  onClick,
}: RadioProps) => {
  const { t } = useTranslationContext();
  const onSelectValue = () => {
    if (disabled) return;
    onClick?.(value, name);
  };

  return (
    <div
      onClick={onSelectValue}
      className={cn(
        "flex items-center w-auto",
        disabled ? "cursor-default" : "cursor-pointer",
        containerStyle
      )}
      data-testid={id}
    >
      <Circle size={circleSize} isSelected={isSelected} />
      {!!label && (
        <div className={cn("ml-2 whitespace-nowrap", labelStyle)}>
          {t(label)}
        </div>
      )}
    </div>
  );
};

export default Radio;
